import React, {useCallback, useState} from 'react';
import {View, Platform, ScrollView} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {StyleSheet} from 'react-native';

import {RNEText} from '../../components';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';
import {useFocusEffect} from '@react-navigation/native';

const PatientConsultationsScreen = () => {
  const {setCanRefresh} = usePullDownRefreshContext();

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  return (
    <SafeAreaView style={sharedStyles.root}>
      {Platform.OS === 'web' ? (
        <ScrollView>
          <View style={webStyles.mainContainer}>
            <RNEText
              label="Consultation Screen"
              color="accent"
              weight="bold"
              variant="title"
            />
          </View>
        </ScrollView>
      ) : (
        <ScrollView
          onScroll={handleScroll}
          onLayout={e => {
            setScrollViewHeight(e.nativeEvent.layout.height);
          }}
          onContentSizeChange={(contentWidth, contentHeight) => {
            setContentHeight(contentHeight);
          }}>
          <View style={mobileStyles.mainContainer}>
            <RNEText
              label="Consultation Screen"
              color="accent"
              weight="bold"
              variant="title"
            />
          </View>
        </ScrollView>
      )}
    </SafeAreaView>
  );
};

export default PatientConsultationsScreen;

const webStyles = StyleSheet.create({
  mainContainer: {
    paddingTop: 120,
    paddingBottom: 32,
    paddingHorizontal: 120,
    width: '100%',
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingVertical: 20,
    paddingHorizontal: 48,
  },
});

const sharedStyles = StyleSheet.create({
  root: {
    height: '100%',
    flexDirection: 'row',
    width: '100%',
  },
});
